// @ts-nocheck
import Component from '@glimmer/component'
import { tracked } from '@glimmer/tracking'
import { action } from '@ember/object'
import { on } from '@ember/modifier'
import { fn } from '@ember/helper'
import Icon from 'customer-flows/components/ui-kit/icon'
import { eq } from 'ember-truth-helpers'

class ValueInspectorComponent extends Component {
  @tracked isExpanded = false

  get valueType() {
    const value = this.args.value
    if (value === null || value === undefined) {
      return 'null'
    }
    if (typeof value === 'boolean') {
      return 'boolean'
    }
    if (typeof value === 'number') {
      return 'number'
    }
    if (typeof value === 'string') {
      return 'string'
    }
    if (Array.isArray(value)) {
      return 'array'
    }
    if (typeof value === 'object') {
      return 'object'
    }
    return 'unknown'
  }

  get isExpandable() {
    return this.valueType === 'array' || this.valueType === 'object'
  }

  get arrayItems() {
    if (this.valueType === 'array') {
      return this.args.value.map((item: any, index: number) => ({
        key: String(index),
        value: item
      }))
    }
    return []
  }

  get objectEntries() {
    if (this.valueType === 'object') {
      return Object.entries(this.args.value).map(([key, value]) => ({
        key,
        value
      }))
    }
    return []
  }

  @action
  toggleExpanded() {
    this.isExpanded = !this.isExpanded
  }

  <template>
    {{#if (eq this.valueType 'null')}}
      <div class='rounded-3 max-h-32 overflow-auto border border-neutrals-100 bg-neutrals-50 px-2 py-1 text-reg-para-12 italic text-neutrals-250'>
        <em>(empty)</em>
      </div>
    {{else if (eq this.valueType 'boolean')}}
      <div class='rounded-3 max-h-32 overflow-auto border border-neutrals-100 px-2 py-1 text-reg-para-12
        {{if @value "bg-green-50 text-green-700" "bg-neutrals-50 text-neutrals-400"}}'>
        {{@value}}
      </div>
    {{else if (eq this.valueType 'number')}}
      <div class='rounded-3 max-h-32 overflow-auto border border-neutrals-100 bg-blue-50 px-2 py-1 font-mono text-reg-para-12 text-blue-700'>
        {{@value}}
      </div>
    {{else if (eq this.valueType 'string')}}
      <div class='rounded-3 max-h-32 break-words overflow-auto border border-neutrals-100 bg-neutrals-50 px-2 py-1 text-reg-para-12 text-neutrals-400'>
        {{@value}}
      </div>
    {{else if (eq this.valueType 'array')}}
      <div class='flex flex-col'>
        <div
          class='flex cursor-pointer items-center gap-1.5 rounded-2 py-1 transition-colors hover:bg-purple-50'
          {{on 'click' this.toggleExpanded}}
        >
          <Icon @src={{if this.isExpanded 'carat-down' 'carat-forward'}} class='shrink-0 text-purple-600 [&_svg]:w-full [&_svg]:h-full' style='width: 10px; height: 10px;' />
          <span class='text-reg-para-12 text-purple-600'>Array ({{@value.length}})</span>
        </div>
        {{#if this.isExpanded}}
          <div class='grid grid-cols-[auto_1fr] items-center gap-x-2 gap-y-1 border-l border-neutrals-200 ml-1 pl-3'>
            {{#each this.arrayItems as |item|}}
              <span class='text-bold-para-12 text-purple-600'>[{{item.key}}]</span>
              <ValueInspectorComponent @value={{item.value}} />
            {{/each}}
          </div>
        {{/if}}
      </div>
    {{else if (eq this.valueType 'object')}}
      <div class='flex flex-col'>
        <div
          class='flex cursor-pointer items-center gap-1.5 rounded-2 py-1 transition-colors hover:bg-orange-50'
          {{on 'click' this.toggleExpanded}}
        >
          <Icon @src={{if this.isExpanded 'carat-down' 'carat-forward'}} class='shrink-0 text-orange-600 [&_svg]:w-full [&_svg]:h-full' style='width: 10px; height: 10px;' />
          <span class='text-reg-para-12 text-orange-600'>Object ({{this.objectEntries.length}})</span>
        </div>
        {{#if this.isExpanded}}
          <div class='grid grid-cols-[auto_1fr] items-center gap-x-2 gap-y-1 border-l border-neutrals-200 ml-1 pl-3'>
            {{#each this.objectEntries as |entry|}}
              <span class='text-bold-para-12 text-orange-600'>{{entry.key}}:</span>
              <ValueInspectorComponent @value={{entry.value}} />
            {{/each}}
          </div>
        {{/if}}
      </div>
    {{else}}
      <div class='rounded-3 max-h-32 break-words overflow-auto border border-neutrals-100 bg-neutrals-50 px-2 py-1 text-reg-para-12 text-neutrals-400'>
        {{@value}}
      </div>
    {{/if}}
  </template>
}

export default ValueInspectorComponent

